import { useQuery } from "@tanstack/react-query";
import { eventsApi } from "@/lib/humhub-api/events";

export const useEventById = (id: number) => {
  // React Queryでデータ取得
  const {
    data: event,
    isLoading: loading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: ["eventDetail", id],
    queryFn: () => eventsApi.getEventById(id),
    enabled: id > 0, // 有効なIDの場合のみクエリ実行
    staleTime: 5 * 60 * 1000, // イベント詳細は5分間キャッシュ
  });

  return {
    data: event || null,
    isLoading: loading,
    error: queryError ? String(queryError) : null,
    refetch: () => refetch(),
  };
};

export const useEventByIdOptional = (id?: number | null) => {
  return useEventById(id ?? 0);
};
